<template>
  <div>
    <button @click="showJs = !showJs">Göster/Gizle</button>
    <transition
        :css="false"
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @after-enter-cancelled="afterEnterCancelled"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
        @after-leave-cancelled="afterLeaveCancelled"
    >
      <div v-if="showJs" class="box">
        Deneme
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AnimationInJs",
  data() {
    return {
      showJs: false,
      width : 200
    }
  },
  methods: {
    beforeEnter(el) {
      console.log("beforeEnter");
      this.width = 200;
      el.style.width = this.width;
    },
    enter(el, done) {
      let round = 1;
      const animation = setInterval(() => {
        el.style.width = (this.width + round * 10) + "px";
        round++
        if (round > 20){
          clearInterval(animation);
          done();
        }
      }, 50)
    },
    // eslint-disable-next-line no-unused-vars
    afterEnter(el) {
      console.log("afterEnter")
    },
    // eslint-disable-next-line no-unused-vars
    afterEnterCancelled(el) {
      console.log("afterEnterCancelled")
    },
    beforeLeave(el) {
      this.width = 400;
      el.style.width = this.width;
    },
    leave(el, done) {
      let round = 1;
      const animation = setInterval(() => {
        el.style.width = (this.width - round * 10) + "px";
        round++
        if (round > 20){
          clearInterval(animation);
          done();
        }
      }, 50)
    },
    // eslint-disable-next-line no-unused-vars
    afterLeave(el) {
      console.log("afterLeave")
    },
    // eslint-disable-next-line no-unused-vars
    afterLeaveCancelled(el) {
      console.log("afterLeaveCancelled")
    }
  }
}
</script>

<style scoped>
button {
  margin: 20px 50px;
  background-color: wheat;
  color: green;
  font-size: 14px;
  padding: 15px;
  outline: none;
  border-radius: 5px;
  cursor: pointer;
}
.box {
  width: 200px;
  height: 45px;
  margin-top: 40vh;
  margin-left: 40vw;
  background-color: chartreuse;
  border-radius: 10px;
  padding-top: 20px;
  text-align: center;
}
</style>